import React, { FC } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { EditSubstitute } from '../../../components/EditSubstitute.tsx';
import { SubstituteView } from '../../../components/SubstituteView';

export const SubstituteModal: FC<{
  internalNumber: string;
  currentDate: Date;
  onClose: () => void;
  title: string,
  isEdit: boolean,
  subExist?: number,
}> = ({
  internalNumber,
  currentDate,
  onClose,
  title,
  isEdit,
  subExist = 0,
}) => (
  <Dialog
    open
    onClose={onClose}
    maxWidth="md"
    fullWidth
  >
    <div className="align-status">
      <div className="left">
        <DialogTitle>{title}</DialogTitle>
      </div>
      <IconButton sx={{ marginRight: '15px' }} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </div>
    <DialogContent>
      {isEdit ? (
        <EditSubstitute
          id={internalNumber}
          currentDate={currentDate}
          subExist={subExist}
          onClose={onClose}
        />
      ) : (
        <SubstituteView
          id={internalNumber}
          currentDate={currentDate}
          onClose={onClose}
        />
      )}
    </DialogContent>
  </Dialog>
);
